import { render } from "./SoldoutDpPage.vue?vue&type=template&id=5125091f"
import script from "./SoldoutDpPage.vue?vue&type=script&lang=js"
export * from "./SoldoutDpPage.vue?vue&type=script&lang=js"

import "./SoldoutDpPage.vue?vue&type=style&index=0&id=5125091f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__